import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Form, Image, Label } from 'semantic-ui-react';
import * as yup from 'yup';
import styled from 'styled-components';
import { ShadowBox } from '../elements/Common';
import { GreyLink, StyledButton } from '../elements/Button';
import { ControlledTextFormField } from '../elements/FormField';
import { ToastMessage } from '../utility/toast';
import { UserService } from '../utility/services/user';
import { Images } from '../images';

const LoginContainer = styled.div`
  min-height: 100vh;
  position: relative;
  z-index: 2;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;

  .verificationContainer {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }

  .verificationContainer > div {
    flex: 1;
    padding: 4px;
  }

  .verificationInputContainer {
    display: flex;
    flex: 1;
    min-height: 60px;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    margin-bottom: 1.5em;
  }

  .verificationContainerMobile {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }

  .verificationContainerMobile > div {
    flex: 1;
    padding: 1px;
  }

  .verificationContainerMobile {
    display: flex;
    flex: 1;
    min-height: 60px;
    font-weight: bold;
    line-height: 23px;
    margin-bottom: 1.5em;
  }
`;

const PageContainer = styled.div`
  background: ${({ theme }) => theme.colors.box};
`;

const Box = styled(ShadowBox)`
  padding: 3em 2em;
  width: 432px;
  @media only screen and (max-width: 768px) {
    width: calc(100% - 20px);
  }
`;

const LoginText = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  margin-bottom: 1.5em;
`;

const Logo = styled(Image)`
  height: auto;
  width: 220px;
`;

const LogoContainer = styled.a`
  z-index: 9;
  margin-bottom: 50px;
`;

const LoginSchema = yup.object().shape({
  email: yup.string().required('Email is required').email('Enter a valid email'),
});

function LoginBox({ loading, loginClicked, errors, error, formLoading, control }) {
  return (
    <Box>
      <LoginText>Forgot Password</LoginText>
      <Form loading={formLoading} onSubmit={loginClicked}>
        <ControlledTextFormField
          error={errors.email}
          label="Email Address"
          name="email"
          control={control}
          hint={errors?.email?.message}
          required
        />

        {error && (
          <Label as="h4" color="red" data-testid="error">
            {error}
          </Label>
        )}

        <StyledButton loading={loading} fluid type="submit">
          Send Link
        </StyledButton>
      </Form>
      <div className="d-flex justify-content-center mt-3">
        <GreyLink href="/login" className="ml-1">
          Back to Login
        </GreyLink>
      </div>
    </Box>
  );
}
LoginBox.displayName = 'LoginBox';

export function ForgotPasswordPage() {
  const [logging, setLogging] = useState(false);

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    resolver: yupResolver(LoginSchema),
    shouldUnregister: true,
  });

  const onSubmit = async data => {
    try {
      setLogging(true);
      await UserService.forgotPassword(data);
      ToastMessage.success(
        'An e-mail has been sent successfully, please check your e-mail for the next steps.',
      );
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLogging(false);
    }
  };

  return (
    <PageContainer>
      <LoginContainer>
        <LogoContainer>
          <Logo src={Images.blackLogo} />
        </LogoContainer>
        <LoginBox
          control={control}
          errors={errors}
          loading={logging}
          loginClicked={handleSubmit(onSubmit)}
        />
      </LoginContainer>
    </PageContainer>
  );
}
